import LabelProvider from "core/components/label/LabelProvider";

export default LabelProvider.create({

	DateSelect: {
		k: "dateReminder.dialog.title",
		v: "Select a date"
	},

	Welcome: {
		k: "welcome",
        v: "Welcome"
	},

	StudyPlanCustomize: {
		k: "dateReminder.dialog.title",
		v: "###Let's customize your study plan.",
		allowMarkdown: true,
		type:"markdown"
	},

	TargetExamDate: {
		k: "dateReminder.dialog.subtitle",
		v: "#### Whens your target exam date?",
		allowMarkdown: true,
		type:"markdown"
	},

	SelectExamDate: {
		k: "dateReminder.body.choose",
		v: "Select an exam date"
	}
});



// WEBPACK FOOTER //
// ./src/panels/dateReminder/DateReminder.labels.ts